import { keyframes, SxProps, useTheme } from '@mui/material';

export const useStyles = (): { [key: string]: SxProps } => {
const theme = useTheme();

  return {
    rotateIcon_slow: {
      animation: `${keyframes`
          0% {
              transform: rotate(360deg);
          }
          100% {
              transform: rotate(0deg);
          }
      `} 4s linear infinite`,
    },
    rotateIcon_wiggle: {
      animation: `${keyframes`
          0% {
              transform: rotate(-35deg);
          }
          10% {
              transform: rotate(790deg);
          }
          80% {
              transform: rotate(-35deg);
          }
          90% {
              transform: rotate(0deg);
          }
          100% {
              transform: rotate(0deg);
          }
      `} 4s linear infinite`,
    },
    scrollbar: {
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.grey[400],
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.grey[40],
      },
    },
  };
};
